import React from 'react';
import { translate } from '../Services/translation';
import RestoreIcon from '@mui/icons-material/Restore';
import { clearRecentlyViewed, clearRecentSearches } from '../Actions/QuickSearch.action';
import { useDispatch } from 'react-redux';


const QuickSearchResultRecentItems = ({ recentSearches, recentlyViewed, searchUrl }) => {
    const dispatch = useDispatch();

    const renderList = (list, title, type) => {
        const classNamePrefix = type;

        return (
            <>
                {list?.length > 0 &&
                    <div className="quick-search-result__header quick-search-result__header--recent">
                        <h3 className="quick-search-result__title">{title}</h3>
                        {type === 'searches' && (
                            <button className="quick-search-result__clear-all-button" onClick={() => dispatch(clearRecentSearches())}>{translate("code.search.recentsearches.clearall")}</button>
                        )}
                        {type === 'viewed' && (
                            <button className="quick-search-result__clear-all-button" onClick={() => dispatch(clearRecentlyViewed())}>{translate("code.search.recentlyviewed.clearall")}</button>
                        )}
                    </div>
                }
                <ul className={`quick-search-result__list ${classNamePrefix}`}>
                    {list?.length > 0 && list.map((item, index) => {
                        switch (type) {
                            case 'searches':
                                return (
                                    <li
                                        key={index}
                                        className="quick-search-result__item"
                                    >
                                        <a
                                            className="quick-search-result__link"
                                            href={searchUrl + '?q=' + item}
                                        >
                                            <RestoreIcon
                                                className="quick-search-result__recent-icon"
                                                sx={{ fontSize: 20 }} />
                                            {item}
                                        </a>
                                    </li>
                                );

                            case 'viewed':
                                return (
                                    <li
                                        key={index}
                                        className="quick-search-result__item"
                                    >
                                        <a
                                            className="quick-search-result__link"
                                            href={item.url}
                                        >
                                            <img src={item.imageUrl} className="quick-search-result__thumbnail" />

                                            {item.name}
                                        </a>
                                    </li>
                                );

                            default:
                                return null;
                        }

                    })}
                </ul>
            </>
        )
    }

    return (
        <div className="quick-search-result">
            {renderList(recentSearches, translate('code.search.recentsearches'), 'searches')}
            {renderList(recentlyViewed, translate('code.search.recentlyviewed'), 'viewed')}
        </div>
    );
};

export default QuickSearchResultRecentItems;